import { Image, ImageProps } from '../../Image'
import { LinkProps } from '../../Link'
import { useCardContext } from '../CardProvider'
import { renderWithOptionalLink } from '../utils'
import { Container, ImgContainer } from './styles'

export interface CardImageProps {
  className?: string
  images: ImageProps[]
  priority?: boolean
  href?: LinkProps['href']
  as?: LinkProps['as']
  external?: LinkProps['external']
  target?: LinkProps['target']
}

export const CardImage = ({
  className,
  images,
  priority,
  href,
  as,
  external,
  target,
}: CardImageProps) => {
  const { layout } = useCardContext()

  // Use the first two images
  const imageProps = images.slice(0, 2)

  return renderWithOptionalLink(
    <Container
      className={className}
      split={images.length !== 1}
      layout={layout}
    >
      {imageProps.map((imageProp, i) => (
        <ImgContainer key={i}>
          <Image {...imageProp} fill sizes="300px" priority={priority} />
        </ImgContainer>
      ))}
    </Container>,
    { href, as, external, target },
  )
}
